import { Event } from '../_base/eventBus/EventBus';

export class CurrentUnitChanged implements Event {
    constructor(public unitId: number) {
    }
}
